export interface IBranchNameValidationResult {
  valid: boolean;
  error?: string;
}

export interface IBranchNameValidationOptions {
  existingNames?: readonly string[];
  currentName?: string;
}

export const BRANCH_NAME_MAX_LENGTH: number = 50;
const BRANCH_NAME_PATTERN: RegExp = /^[A-Za-z0-9]+$/;
const RESERVED_BRANCH_NAMES: readonly string[] = ["master", "main", "head"];

export const validateBranchName = (
  rawName: string,
  options: IBranchNameValidationOptions = {}
): IBranchNameValidationResult => {
  const name: string = (rawName ?? "").trim();

  if (name.length === 0) {
    return { valid: false, error: "Branch name cannot be empty." };
  }
  if (name.length > BRANCH_NAME_MAX_LENGTH) {
    return {
      valid: false,
      error: `Branch name cannot exceed ${BRANCH_NAME_MAX_LENGTH} characters.`
    };
  }
  if (!BRANCH_NAME_PATTERN.test(name)) {
    return {
      valid: false,
      error: "Only letters (A–Z, a–z) and digits (0–9) are allowed."
    };
  }

  const lower: string = name.toLowerCase();

  if (RESERVED_BRANCH_NAMES.includes(lower) && options.currentName?.toLowerCase() !== lower) {
    return { valid: false, error: `"${name}" is a reserved branch name.` };
  }

  if (options.existingNames) {
    const currentLower: string | undefined = options.currentName?.toLowerCase();
    const conflict: boolean = options.existingNames.some(
      (existing: string) => existing.toLowerCase() === lower && existing.toLowerCase() !== currentLower
    );
    if (conflict) {
      return { valid: false, error: "A branch with this name already exists." };
    }
  }

  return { valid: true };
};
